import { isEmail, isName } from 'utils';
import {
  AddDataRoomsTableKeys,
  IGNORE_COLUMNS,
  REQUIRED_COLUMNS,
  TABLE_COLUMNS,
} from './data';
import { DataRoomSheet } from 'router/subrouters/DataRoom/models/DataRoom';

export const checkIfColumnIsValid = (column: string) =>
  TABLE_COLUMNS.includes(column as AddDataRoomsTableKeys);

export const checkHasEveryRequiredColumn = (columns: string[]) =>
  REQUIRED_COLUMNS.every((col) => columns.includes(col));

export const checkIsNotIgnoreColumn = (column: string) =>
  !IGNORE_COLUMNS.includes(column);

export const checkIsValidName = (value: string) => !!value && isName(value);

export const checkIsValidEmail = (value: string) => !!value && isEmail(value);

export const checkAreAllRequiredFieldsValid = (dataRooms: DataRoomSheet[]) =>
  !dataRooms.some(
    ({ dataRoomName, ownerEmail, ownerFirstName, ownerLastName }) =>
      !dataRoomName ||
      !checkIsValidEmail(ownerEmail) ||
      !checkIsValidName(ownerFirstName) ||
      !checkIsValidName(ownerLastName),
  );

export const getArrayOfColleagueEmails = (colleagues: any) =>
  (Array.isArray(colleagues)
    ? colleagues
    : typeof colleagues === 'string'
    ? colleagues
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : []
  )?.filter(isEmail);
